<template>
	<div class="tpl appointment-list-wrap">
		<mt-header title="同城相约" fixed>
		  <router-link to="/finds" slot="left">
		    <mt-button icon="back"></mt-button>
		  </router-link>
		  <mt-button class="add-appointment-btn" @click.native="goToMyAppiontment" icon="more" slot="right"></mt-button>
		</mt-header>
		
		<div class="list-filter">
			<span class="btn add-filter-btn" :class="{'active':filterValue=='1'}" @click="filterList('1')">地址 <img src="../../assets/img/finds/ic_find_list_pdl_nor@2x.png"/></span>
			<span class="btn other-filter-btn" :class="{'active':filterValue=='2'}" @click="filterList('2')">筛选<img src="../../assets/img/finds/ic_find_list_filter_nor@2x.png"/></span>
		</div>
		<div class="filter-add-wrap" v-if="filterValue=='1'">
			<div class="add-list">
				<ul>
					<li v-for="item in addressInfo.area" :class="{'active':item.region_name==areaName}" @click="getAddressInfo(item)">{{item.region_name}}</li>
				</ul>
			</div>
			<!--<div class="add-content">
				<ul>
					<li v-for="item in addressInfo.city" :class="{'active':item.region_id==addressId.city}" @click="getAddressInfo(item.region_id,'city','area')">{{item.region_name}}</li>
				</ul>
			</div>
			<div class="add-content">
				<ul>
					<li v-for="item in addressInfo.area" :class="{'active':item.region_id==addressId.area}" @click="getAddressInfo(item.region_id,'area','')">{{item.region_name}}</li>
				</ul>
			</div>-->
		</div>
		<div class="filter-other-wrap" v-if="filterValue=='2'" @click.self="filterValue=0">
			<div class="filter-other-content">
				<p class="filter-other-title">约会主题</p>
				<ul>
					<li :class="{'active':choosedFilterOtherId.theme==''}" @click="choosedFilterOtherId.theme=''">全部</li>
					<li v-for="item in appointmentThemeList" :class="{'active':item.name==choosedFilterOtherId.theme}" @click="choosedFilterOtherId.theme=item.name">{{item.name}}</li>
					<!--<li v-for="item in otherThemeList" :class="{'active':item.s_id==choosedFilterOtherId.theme}" @click="choosedFilterOtherId.theme=item.s_id">{{item.name}}</li>-->
				</ul>
				<p class="filter-other-title">消费类型</p>
				<ul>
					<li v-for="item in filterOtherTypeList" :class="{'active':item.id==choosedFilterOtherId.type}" @click="choosedFilterOtherId.type=item.id">{{item.name}}</li>
				</ul>
				<p class="filter-other-title">其他</p>
				<ul>
					<li :class="{'active':choosedFilterOtherId.sex==0}" @click="choosedFilterOtherId.sex=0">全部</li>				
					<li :class="{'active':choosedFilterOtherId.sex==1}" @click="choosedFilterOtherId.sex=1">只看男生</li>				
					<li :class="{'active':choosedFilterOtherId.sex==2}" @click="choosedFilterOtherId.sex=2">只看女生</li>				
					<li :class="{'active':choosedFilterOtherId.preMoney==1}" @click="choosedFilterOtherId.preMoney==''?choosedFilterOtherId.preMoney=1:choosedFilterOtherId.preMoney=''">有诚意金</li>				
					<li :class="{'active':choosedFilterOtherId.isGift==1}" @click="choosedFilterOtherId.isGift==''?choosedFilterOtherId.isGift=1:choosedFilterOtherId.isGift=''">礼物赠送</li>			
				</ul>
				<div class="filter-btns">
					<button class="reset" @click="choosedFilterOtherId={theme:'',type:'3',sex:'',preMoney:'',isGift:''}">重置</button>
					<button class="submit" @click="submitFilterOther()">确定</button>
				</div>
			</div>
		</div>
		
		<div class="appointment-list">
			<mt-loadmore :top-method="refreshAppointmentList" :bottom-method="loadMoreAppointmentList" :auto-fill="false" ref="loadmore">
				<mt-cell v-for="(item,index) in aList" :key="item.r_id" @click.native="goToAppointmentDetail(item.r_id,item.uid)">
				  <div class="list-item">
				  	<div class="user-info">
				  		<div class="user-img">
				  			<img :src="item.avatar" alt="" />
				  		</div>
				  		<div class="user-text">
				  			<p class="user-intro">
				  				<span class="user-nickname">{{item.nickname}}</span>
				  				<span class="user-sex">
				  					<img v-if="item.gender == 1" src="../../assets/img/finds/ic_user_man@2x.png" alt="" />
				  					<img v-if="item.gender == 2" src="../../assets/img/finds/ic_user_woman@2x.png" alt="" />
				  				</span>
				  				<span class="user-age">{{item.age}}岁</span>
				  			</p>
				  			<p class="item-msg">{{item.Message||"此用户没有约会宣言"}}</p>
				  			<p class="item-tags">
				  				<span class="is-pre-money">{{item.earnest_money==0?"无诚意金":"有诚意金"}}</span>
				  				<span class="is-gift">{{item.gift==1?"有礼物":"没有礼物"}}</span>
				  			</p>
				  		</div>
				  	</div>
				  	<div class="appointment-info">
				  		<div>
				  			<p><img src="../../assets/img/finds/ic_find_list_theme@2x.png"/>{{item.name}}</p>
				  			<p><img src="../../assets/img/finds/ic_find_list_place@2x.png"/>{{item.region_name}}</p>
				  		</div>
				  		<div>
				  			<p><img src="../../assets/img/finds/ic_find_list_time@2x.png"/>{{item.release_time|toDateTime|convertTime("YYYY-MM-DD")}}</p>
				  			<p><img src="../../assets/img/finds/ic_find_list_contyp@2x.png"/><span v-if="item.consumption_type==0">AA</span><span v-if="item.consumption_type==1">我买单</span><span v-if="item.consumption_type==2">你买单</span></p>
				  		</div>
				  		<div>
				  			<button class="accept-appointment" @click.stop="joinAppointment(item.uid,item.r_id)">应约</button>
				  		</div>
				  	</div>
				  </div>
				</mt-cell>
				<div class="no-content" v-if="!aList">
					<img src="../../assets/img/default/bg_img_empty@2x.png"/>
					<p>(〃'▽'〃)这里空空哒~</p>
				</div>
			</mt-loadmore>
			
		</div>
		
		<div class="send-appointment-btn">
			<router-link class="go-to-send" :to="{name:'send-appointment'}"><img src="../../assets/img/finds/btn_find_list_publish@2x.png"/></router-link>
		</div>
		
		<get-position @getPosition="getPosition"></get-position>
	</div>
</template>

<script>
	import GetPosition from '../Common/GetPosition'
	export default{
		name:"Appointment-list",
		components:{
			GetPosition
		},
		data(){
			return{
				uid:"",		//当前用户id
				searchValue:"",		//搜索关键字
				aList:[],	//约会列表
				nowAddress:"",
				areaName:"",
				nowPage:1,	//当前页码
				filterValue:"0",	//当前筛选选项
				choosedFilterOtherId:{		//其他条件筛选当前选中选项的id
					theme:"",
					type:"3",
					sex:"",
					preMoney:"",
					isGift:""
				},
				addressInfo:{	//接口获取到的地址信息
					prov:"",	//省
					city:"",	//市
					area:"",	//区
				},	
				addressId:{		//存放当前选中的地址的id
					prov:"",	//省
					city:"",	//市
					area:"",	//区
				},
				appointmentThemeList:[],		//约会主题列表
				filterOtherTypeList:[
					{id:0,name:"AA制"},
					{id:1,name:"我买单"},
					{id:2,name:"你买单"},
					{id:3,name:"全部"},
				],
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.nowAddress = this.$store.state.nowAddress;	//获取当前用户的id
			this.$store.commit("changeTabChoosed","finds");		//属于finds模块
			this.$store.commit("changeTabBarShow",false);	//不显示navbar
			
			this.getList(this.nowAddress);
		},
		watch:{
			filterValue(){
				if(this.filterValue==1){
					this.getAddressInfo();
					
				}else if(this.filterValue==2){
					this.getAppointmentThemeList();
				}
			},
		},
		mounted(){
			
		},
		methods:{
			getPosition(data){
				console.log(data);
				this.nowAddress = data.name;
				console.log(this.nowAddress);
				this.getList();		//获取列表数据
			},
			//获取约会列表内容
			getList(c){
				console.log(this.nowAddress,this.nowPage);
				let city = c?c:this.nowAddress;
				this.$axios({
					url:"Appointment/AppointmentList",
					method:"post",
					data:{
						city:city,
						page:this.nowPage,
						sincerity:this.choosedFilterOtherId.theme,
						consumption_type:this.choosedFilterOtherId.type,
						girl_friend:this.choosedFilterOtherId.sex,
						earnest_money:this.choosedFilterOtherId.preMoney,
						gift:this.choosedFilterOtherId.isGift
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						if(this.nowPage==1){
							this.aList = res.data.data;
						}else{
							if(res.data.data.length<1){
								this.$toast({
									message:"没有更多内容了~",
									position:"bottom",
									duration:3000
								})
								this.nowPage--;
							}else{
								this.aList = this.aList.concat(res.data.data);
							}
						}
					}else{
						this.$toast({
							message:"没有更多内容了~",
							position:"bottom",
							duration:3000
						})
						this.nowPage--;
					}
				})
				.catch(err=>{
					console.log(err);
					this.$indicator.close();
					this.$toast({
						message:"加载超时，请重试",
						position:"bottom",
						duration:3000
					})
				})
			},
			//切换筛选条件
			filterList(v){
				if(this.uid){
					if(this.filterValue == v){
						this.filterValue = 0;
					}else{
						this.filterValue = v;
					}
				}else{
					this.$toast({
						message:"请登录！",
						position:"bottom",
						duration:3000
					})
				}
				
			},
			//获取城市地址信息
			getAddressInfo(item){
				console.log(item,this.nowAddress);
				let add = item?item.region_name:this.nowAddress;
				console.log(add)
				this.$axios({
					url:"Currency/getRegionInfoList",
					method:"post",
					data:{
						region_name:add
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.addressInfo.area = res.data.data;
					}else{
						this.filterValue = "0";
						this.areaName = item.region_name;
						this.getList(this.areaName)
					}
					
				}).catch(err=>{
					console.log(err)
				})
			},
			//获取约会主题列表
			getAppointmentThemeList(){
				this.$axios({
					url:"Appointment/SearchAppointmentSincerity",
					method:"post",
					data:{}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.appointmentThemeList = res.data.data;
					}else{
						this.appointmentThemeList = ""
					}
					
				}).catch(err=>{
					console.log(err)
				})
			},
			//提交筛选并刷新列表
			submitFilterOther(){
				this.filterValue = "0",
				this.getList()
			},
			//进入我的约会列表
			goToMyAppiontment(){
				this.$router.push({"name":"my-appointment"})
			},
			//进入约会详情页
			goToAppointmentDetail(id,uid){
				console.log(this.uid,id,uid);
				if(uid == this.uid){
					this.$router.push({
						name:"appointment-mine",
						query:{
							id:id
						}
					})
				}else{
					this.$router.push({
						name:"appointment-other",
						query:{
							id:id
						}
					})
				}
				
			},
			//申请应约
			joinAppointment(uid,id){
				if(uid==this.uid){
					this.$toast({
						message:"你确定要和自己约会么？",
						position:"bottom",
						duration:3000
					})
					return;
				}else{
					this.$axios({
						url:"Appointment/invitation",
						method:"post",
						data:{
							uid:this.uid,
							r_id:id,
							text:"我想约你~"
						}
					}).then(res=>{
						console.log(res);
						if(res.data.code==200){
							this.$toast({
								message:res.data.msg,
								position:"bottom",
								duration:3000
							})
						}
					}).catch(err=>{
						console.log(err)
					})
				}
				
			},
			refreshAppointmentList(){
				this.nowPage = 1;
				this.getList(this.areaName);
				this.$refs.loadmore.onTopLoaded();
			},
			loadMoreAppointmentList(){
				this.nowPage ++;
				this.getList(this.areaName);
				this.$refs.loadmore.onBottomLoaded();
			}
		}
	}
</script>

<style scoped>
	.appointment-list-wrap{
		padding-top: 5.4rem;
	}
	.add-appointment-btn >>>.mint-button-icon{
		width: 1.8rem;
		height: 1.8rem;
		margin-top: 0.3rem;
		background: url(../../assets/img/finds/ic_find_nav_mydate@2x.png) no-repeat;
		background-size: contain;
		
	}
	.add-appointment-btn >>>.mint-button-icon .mintui-more{
		opacity: 0;
	}
	
	.mint-search {
		position: fixed;
		width: 100%;
		top: 2.5rem;
		left: 0;
		z-index: 10;
		height: auto;
	}
	>>>.mint-searchbar {
		background-color: #fff;
	}
	
	>>>.mint-searchbar-inner {
		background: rgba(40, 40, 40, .12);
		border-radius: 1rem;
		padding: 0 0.8rem;
	}
	
	>>>.mint-searchbar-inner .mintui-search {
		color: #7644FA;
		font-size: 1rem;
	}
	
	>>>.mint-searchbar-inner input {
		background: none;
		padding: 0 0.5rem;
	}
	
	>>>.mint-searchbar-cancel{
		color: #7644FA;
		font-size: 0.8rem;
	}
	>>>.mint-cell-value{
		width: 100%;
	}
	.appointment-list{
		background: #f3f3f3;
		overflow-y: scroll;
	    height: calc(100vh - 5rem);
	}
	.mint-loadmore{
		padding: 0 1rem;
	}
	.list-item{
		width: 100%;
	}
	.mint-cell{
		margin: 1rem 0;
		box-shadow: 3px 4px 5px rgba(16,4,49,0.1);
		border-radius: 0.5rem;
		overflow: hidden;
	}
	.list-item .user-img img{
		width: 5rem;
		border-radius: 5px;
	}
	.list-item .user-text{
		padding: 0 1rem;
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}
	.list-item .user-info{
	    display: flex;
	    justify-content: flex-start;
	    padding: 1rem 0.3rem;
	    border-bottom: 1px solid #f3f3f3;
	}
	.list-item .user-info .user-nickname{
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
	}
	
	.list-item .user-info .user-sex img{
		width: 1.6rem;
		display: inline-block;
	}
	.list-item .user-info .user-age{
		font-size: 0.8rem;
		color: #282828;
	}
	.list-item .user-info .item-msg{
		font-size: 0.8rem;
		color: #7b7b7b;
		line-height: 1.5rem;
		margin-bottom: 0.3rem;
	}
	.list-item .user-info .item-tags span{
		display: inline-block;
		font-size: 0.65rem;
		line-height: 1rem;
		padding: 0.2rem 0.5rem;
		border-radius: 5px;
		margin-right: 0.5rem;
	}
	.list-item .user-info .item-tags span.is-pre-money{
		border: 1px solid #5415f9;
		color: #5415f9;
	}
	.list-item .user-info .item-tags span.is-gift{
		border: 1px solid #FF6161;
		color: #FF6161;
	}
	.appointment-info{
		display: flex;
		justify-content: space-between;
		align-content: center;
		padding: 0.5rem 0;
		color: #282828;
	}
	.appointment-info p{
		padding: 3px 0;
	}
	.appointment-info>div{
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		font-size: 0.8rem;
		line-height: 1.6rem;
	}
	.appointment-info img{
		width: 1.6rem;
		margin-right: 0.3rem;
	}
	.appointment-info .accept-appointment{
		padding: 0.2rem 1rem;
		color: #5415f9;
		border: 1px solid rgba(84,21,249,.5);
		border-radius: 2rem;
		background: none;
		outline: 0;
	}
	.appointment-info .accept-appointment:active{
		background: #7644FA;
		color: #fff;
	}
	.list-filter{
	    position: fixed;
	    width: 100%;
	    top: 2.5rem;
	    left: 0;
	    font-size: 1rem;
	    font-weight: bold;
	    display: flex;
	    justify-content: space-between;
	    padding: 0.5rem;
	    line-height: 2rem;
	    color: #282828;
	    z-index: 10;
	    background: #fff;
	    border-bottom: 1px solid #f3f3f3;
	}
	.list-filter .btn{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	    padding: 0 0.5rem;
	}
	.list-filter .btn img{
		width: 1.6rem;
	}
	.list-filter .btn.active{
		color: #7644FA;
	}
	.list-filter .add-filter-btn.active img{
		transform: rotate(180deg);
	}
	.filter-add-wrap{
		display: flex;
		justify-content: flex-start;
		padding-bottom: 1rem;
	    position: fixed;
	    width: 100%;
	    background: rgba(255,255,255,.95);
	    z-index: 10;
        max-height: calc(100vh - 5.4rem);
	}
	.filter-add-wrap .add-list{
		max-height: calc(100vh - 5.4rem);
		overflow-y: scroll;
	}
	.filter-add-wrap .add-list li{
		font-size: 0.8rem;
	    color: #282828;
	    line-height: 1.5rem;
	    padding: 0.5rem;
	    padding-left: 1rem;
	}
	.filter-add-wrap .add-content{
		flex: 1;
		padding: 0 1rem;
		max-height: calc(100vh - 5.4rem);
		overflow-y: scroll;
	}
	.filter-add-wrap .add-content li{
		font-size: 0.8rem;
	    color: #282828;
	    line-height: 1.5rem;
	    padding: 0.5rem 1rem;
	}
	.filter-add-wrap li.active{
		color: #7644FA;
	}
	.filter-other-wrap{
		position: fixed;
	    z-index: 11;
	    background: rgba(0,0,0,.2);
	    width: 100%;
	    height: 100vh;
	    display: flex;
	    justify-content: flex-end;
	    top: 0;
	    left: 0;
	}
	.filter-other-content{
		width: 85%;
		background: rgba(255,255,255,.95);
		padding: 1rem 1rem 3rem;
		position: relative;
	}
	.filter-btns{
		position: absolute;
		width: 100%;
		left: 0;
		bottom: 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.filter-btns button{
		flex: 1;
		font-size: 1rem;
		line-height: 2.5rem;
		outline: 0;
		border: 0;
	}
	.filter-btns button.reset{
		background: #fefefe;
		color: #282828;
	}
	.filter-btns button.submit{
		background: #7644FA;
		color: #fff;
	}
	.filter-other-content .filter-other-title{
		font-size: 1rem;
		line-height: 1.5rem;
		color: #282828;
		margin-bottom: 1rem;
		margin-top: 0.5rem;
	}
	.filter-other-content li{
		display: inline-block;
		font-size: 0.65rem;
		line-height: 1.2rem;
		padding: 0.3rem 0.8rem;
		border: 1px solid #5415F9;
		margin: 0.5rem 0.3rem;
		background: #ddd0fe;
		color: #282828;
		border-radius: 2rem;
		text-align: center;
		min-width: 25%;
		box-sizing: border-box;
	}
	.filter-other-content li.active{
		background: #ddd0fe;
		border:1px solid #6d34fb;
		color: #7644FA;
	}
	.send-appointment-btn{
	    position: fixed;
	    right: 1rem;
	    bottom: 2rem;
	}
	.send-appointment-btn img{
		width: 5rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Finds/AppointmentList.vue